export default __webpack_public_path__ + "static/media/love.b0f3ad9e.mp3";